import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type MutationOptions, gqlFetcher } from '../fetcher';
import { CreateTemplate } from '../mutations/createTemplate.mutation';
import type { CreateTemplateMutation, CreateTemplateMutationVariables } from '../types';

export const useCreateTemplateMutation = (
  options?: MutationOptions<CreateTemplateMutation, CreateTemplateMutationVariables>,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(CreateTemplate), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('template'),
      });
    },
  });
};
